import Swal from 'sweetalert2'
import Vue from 'vue'

const toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    onOpen: toast => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default class SwalWrapper {
    public confirm = {
        delete() {
            return Swal.fire({
                title: Vue.prototype.$translator.language.data.plugins.swall.confirm.titreSuppression,
                text: Vue.prototype.$translator.language.data.plugins.swall.confirm.texteSuppression,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: Vue.prototype.$translator.language.data.plugins.swall.confirm.confirmSuppression,
                cancelButtonText: Vue.prototype.$translator.language.data.plugins.swall.confirm.cancelSuppression
            })
        },
        custom(titre: string, message: string, ok: string, cancel: string) {
            return Swal.fire({
                title: titre,
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: ok,
                cancelButtonText: cancel
            })
        },
        noCancel(titre: string, message: string, ok: string) {
            return Swal.fire({
                title: titre,
                text: message,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: ok
            })
        },
        yesCancel(titre: string, message: string, ok: string) {
            return Swal.fire({
                title: titre,
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: ok,
                cancelButtonText: Vue.prototype.$translator.language.data.plugins.swall.confirm.cancel,
                cancelButtonColor: '#d33'
            })
        }
    }

    public toast = {
        success(message?: string) {
            toast.fire({
                icon: 'success',
                title: message ?? Vue.prototype.$translator.language.data.plugins.swall.toast.success
            })
        },
        error(message?: string) {
            toast.fire({
                icon: 'error',
                title: message ?? Vue.prototype.$translator.language.data.plugins.swall.toast.error
            })
        },
        info(message: string) {
            toast.fire({
                icon: 'info',
                title: message
            })
        },
        errorApi(err: any) {
            if (!err) this.error(Vue.prototype.$translator.language.data.plugins.swall.erreurServeur)
            else if (err.response?.data?.errors?.msg)
                err.response.data.errors.msg.forEach((x: any) => {
                    this.error(`[${Vue.prototype.$translator.language.data.plugins.swall.codeErreur} : ${err.response.data.status}] ${x}`)
                })
            else this.error(err.response ? `[${Vue.prototype.$translator.language.data.plugins.swall.codeErreur} : ${err.response.status}] ${err.response.statusText}` : Vue.prototype.$translator.language.data.plugins.swall.erreurServeur)
        }
    }

    public prompt = (message: string, password = false) => {
        return Swal.fire({
            title: message,
            input : password ? 'password' : 'text',
            confirmButtonText: 'Valider',
            showCancelButton: true,
        })
    }
}
